import ApiClient from "@/domain/core/utils/apiClient"
import client_core from "@/services/clients/client_core"

const client = new ApiClient(client_core)

const endpoints = {
    list: '/dashboard/v2/admin/certifications/',
    detail: '/dashboard/v2/admin/certifications/{id}/',
    approve: '/dashboard/v2/admin/certifications/{id}/approve/',
    reject: '/dashboard/v2/admin/certifications/{id}/reject/',
}

export default {
    async fetchList(filters, pagination, sorting) {
        let result = await client.get(endpoints.list, {
            ...filters,
            page_size: pagination.page_size ?? 20,
            page: pagination.page ?? 1,
            ordering: sorting.desc ? `-${sorting.column}` : sorting.column ?? '-submitted_at'
        })
        return {
            results: result.results,
            pagination: {
                num_pages: result.pagination.num_pages,
                page_size: result.pagination.page_size,
                page: result.pagination.page_number,
                total: result.pagination.total,
            }
        }
    },

    async fetchDetail(id) {
        return await client.get(endpoints.detail.replace('{id}', id))
    },

    async approve(id) {
        return await client.post(endpoints.approve.replace('{id}', id), {})
    },

    async reject(id, rejectedReason) {
        return await client.post(endpoints.reject.replace('{id}', id), {
            rejected_reason: rejectedReason
        })
    }
}
